import type { SubscriptionLimitsResponse } from "@/schemas/subscription-limits.schema";
import { api } from "@/services/api";

export const subscriptionLimitsApi = {
  /**
   * Get all subscription limits and usage for the current organization
   *
   * Backend endpoint: GET /subscription/limits
   *
   * @returns Subscription limits including resource usage and feature flags
   *
   * @example
   * ```ts
   * const limits = await subscriptionLimitsApi.getLimits();
   * // { subscription: "free", limits: [...], features: [...] }
   * ```
   */
  async getLimits() {
    const { data } = await api.get<SubscriptionLimitsResponse>("/subscription/limits");
    return data;
  },
};
